const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxNjEzLCJjb25ncmVzc0lkIjoxMzYzLCJkYXRlIjoiMjAyMi0xMC0xN1QxMzoxOToxMC42NDVaIiwiaWF0IjoxNjY2MDEyNzUwfQ.0ethxJbTN4bqSIMYnYZJdae-l5UW1zvJGqflwNbyyIs';
const PLANNER_API_URL = 'https://iser2023.planner.documedias.systems/api';

// Development
 //const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxNjE0LCJjb25ncmVzc0lkIjoxMzYzLCJkYXRlIjoiMjAyMi0xMC0xN1QxMzo1MToyMS42MTBaIiwiaWF0IjoxNjY2MDE0NjgxfQ.vSc_HitFzWl2e-8w2NTYiy44wC9e8Nn-3aXvE7bbWno';
 //const PLANNER_API_URL = 'http://localhost:8000/api';

const PLANNER_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMC0wNy0wOVQwNzo0MzoxNS4zMjRaIiwiaWQiOjI3MjYzLCJpYXQiOjE1OTQyODA1OTV9.Br6-wpymBvaIbteoz-rjZuzxnuJB9sTOeP0vUgYkTYk';

const CONGRESS_ID = 1363;
const SUBMISSION_API_URL = 'https://iser2023.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{ids}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  PLANNER_API_URL,
  PLANNER_API_KEY,
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}